import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToasterComponent } from './shared/toaster/toaster.component';
import { OpenInAppBannerComponent } from './shared/open-in-app-banner/open-in-app-banner.component';
import { AppDeepLinkService } from './core/services/app-deep-link.service';

// Shareable routes that should hand off to the native app when opened on a
// phone — mirrors the custom URL scheme paths registered in painel-mobile.
const DEEP_LINK_ROUTE_PATTERNS: RegExp[] = [
  /^\/wishlists\/([^/]+)\/?$/,
  /^\/user\/([^/]+)\/wishlists\/?$/,
];

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToasterComponent, OpenInAppBannerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  private readonly deepLink = inject(AppDeepLinkService);

  title = 'Givo';

  ngOnInit(): void {
    if (typeof window === 'undefined') return;
    const path = window.location.pathname;
    const matches = DEEP_LINK_ROUTE_PATTERNS.some((pattern) => pattern.test(path));
    if (matches) {
      this.deepLink.attemptOpen(path.replace(/^\//, ''));
    }
  }
}
